"use client";
import { Button } from "@/_components/lib/ui/button";
import { GetMuchLatestPosts } from "@/_services/graphql/gql-doc/posts";
import { GetPosts } from "@/_services/graphql/models/Posts";
import { blogLinkBuilder } from "@/_utils";
import { useQuery } from "@apollo/client";
import { Flex, GridItem, SimpleGrid, Skeleton, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useState } from "react";
import { useLocaleDateFormatter } from "@/_hooks/useLocale";

export const CategorySection = () => {
  const listButtons = ["All", "Skills Station", "Career Compass", "Trending"];
  const { data, loading } = useQuery<{ allPost: GetPosts }>(GetMuchLatestPosts);
  const [currentCategory, setCurrentCategory] = useState("All");
  const { dateFormatter } = useLocaleDateFormatter();
  const postByCategory =
    data?.allPost?.filter((post) =>
      currentCategory === "All"
        ? true
        : post.categories?.some((cate) => cate.name === currentCategory),
    ) || [];

  const renderSkeleton = () => {
    return [...Array(6)].map((_, index) => (
      <GridItem key={index}>
        <Skeleton h="14rem" borderRadius="4xl" />
      </GridItem>
    ));
  };
  const isActiveCategory = (cate: string) => cate === currentCategory;
  return (
    <>
      <Flex mt="3rem" mb="2rem" gap={2} flexWrap="wrap">
        {listButtons.map((cate, index) => (
          <Button
            key={index}
            onClick={() => setCurrentCategory(cate)}
            bg={isActiveCategory(cate) ? "black" : "primary.400"}
            h={8}
            size="sm"
            fontWeight="light"
          >
            # {cate}
          </Button>
        ))}
      </Flex>
      {
        <SimpleGrid columns={{ lg: 3, xl: 4 }} gap={6}>
          {loading
            ? renderSkeleton()
            : postByCategory.map((post, index) => (
                <GridItem key={index}>
                  <Link href={blogLinkBuilder(post.slug.current)}>
                    <Flex
                      bgImage={`url(${post.mainImage.asset.url})`}
                      h={{ base: "10rem", md: "14rem" }}
                      bgSize="cover"
                      borderRadius="4xl"
                      transition="transform .5s"
                      _hover={{
                        transform: "scale(1.05)",
                      }}
                      boxShadow="md"
                    />
                    <Text textStyle="md" mt={3} mb={2} fontWeight={600}>
                      {post.title}
                    </Text>
                    <Text textStyle="sm">
                      {dateFormatter(post._createdAt!)}
                    </Text>
                  </Link>
                </GridItem>
              ))}
        </SimpleGrid>
      }
    </>
  );
};
